import { ExtraOptions, RouterModule, Routes } from "@angular/router";
import { NgModule } from "@angular/core";
import { AuthGuard } from "./services/authGuard.service";
import { LandingPageComponent } from "./modules/landing-page/landing-page.component";
import { AboutUsComponent } from "./modules/about-us/about-us.component";
import { ProductViewComponent } from "./modules/product-view/product-view.component";
import { ContactUsComponent } from "./modules/contact-us/contact-us.component";
import { TermsOfServiceComponent } from "./modules/terms-of-service/terms-of-service.component";

const routes: Routes = [
  { path: "home", component: LandingPageComponent },
  { path: "about", component: AboutUsComponent },
  { path: "contact", component: ContactUsComponent },
  { path: "terms", component: TermsOfServiceComponent },

  { path: "product-view/:id", component: ProductViewComponent },

  { path: "**", redirectTo: "" },

  {
    path: "",
    redirectTo: "login",
    pathMatch: "full",
  },
  // {
  //   path: "privacy-policy",
  //   loadChildren: () =>
  //     import("./modules/PrivacyPolicy/privacy-policy.module").then(
  //       (m) => m.PrivacyPolicyModule
  //     ),
  //   // canActivate: [AuthGuard],
  // },

  {
    path: "**",
    redirectTo: "login",
  },
];
const routerOptions: ExtraOptions = {
  scrollPositionRestoration: "top", // <-- Scroll to top on route change
  anchorScrolling: "enabled",
  scrollOffset: [0, 0],
};
@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
